import React from 'react';
import {Navigate, Route, Routes} from 'react-router-dom';

import {useCurrentUser} from 'src/hooks/useCurrentUser';
import {useApprovalRequestSearchCriteria} from 'src/modules/vendor-admin/hooks/useApprovalRequestSearchCriteria';
import {ApprovedRequestsTabContent} from 'src/modules/vendor-admin/tabs/approved-requests-tab-content';

import {AllRequestsTabContent} from './tabs/all-requests-tab-content';
import {DeniedRequestsTabContent} from './tabs/denied-requests-tab-content';
import {PendingRequestsTabContent} from './tabs/pending-requests-tab-content';


export const VendorAdminRouter = () => {
    const {searchCriteria, updateSearchCriteria, loadData} = useApprovalRequestSearchCriteria();
    const {hasAccessToResource, currentUser} = useCurrentUser();
    return (
        <Routes>
            <Route index={true} element={<Navigate to="/vendor-admin/pending" replace={true}/>}/>
            <Route
                path="pending"
                element={(
                    <PendingRequestsTabContent
                        criteria={searchCriteria}
                        onUpdateCriteria={updateSearchCriteria}
                        refreshData={loadData}
                        hasAccessToResource={hasAccessToResource}
                        currentUser={currentUser}
                    />
                )}
            />
            <Route
                path="approved"
                element={(
                    <ApprovedRequestsTabContent
                        criteria={searchCriteria}
                        onUpdateCriteria={updateSearchCriteria}
                        currentUser={currentUser}
                    />
                )}
            />
            <Route
                path="denied"
                element={(
                    <DeniedRequestsTabContent
                        criteria={searchCriteria}
                        onUpdateCriteria={updateSearchCriteria}
                        currentUser={currentUser}
                    />
                )}
            />
            <Route
                path="all"
                element={(
                    <AllRequestsTabContent
                        criteria={searchCriteria}
                        onUpdateCriteria={updateSearchCriteria}
                        currentUser={currentUser}
                    />
                )}
            />
            <Route path="*" element={<Navigate to="/vendor-admin/pending" replace={true}/>}/>
        </Routes>
    );
};
